exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".flexInput {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: end;\n  gap: 20px;\n  margin-top: 10px;\n  margin-bottom: 5px; }\n\n.disabled-btn {\n  pointer-events: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/advance-search/advance-search.component.scss
// module id = 1888
// module chunks = 66